const SET_SUGGESTION_TABLE = (state, payload) => {
    state.suggestion_table = payload.data
}

export {
    SET_SUGGESTION_TABLE,
}